import React, { Component } from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { Field, reduxForm } from "redux-form";
import { toast } from "react-toastify";

import { Button } from "../components/Form";

import {
  required,
  minLengthPassword,
  maxLengthPassword
} from "../lib/validation";

import { renderInput } from "../components/Form";

import { setPassword } from "../auth/actions";

const minLengthPassword8 = minLengthPassword(8);
const maxLengthPassword250 = maxLengthPassword(250);

const isSamePassword = (value, values) => {
  return value !== values["password"] && "Hasła muszą być takie same";
};

class SetPasswordForm extends Component {
  submit = values => {
    const { setPassword, token, reset } = this.props;
    values.token = token;
    return setPassword(values).then(() => {
      reset();
      toast.success("Nowe hasło zostało ustawione!");
    });
  };

  render() {
    const {
      handleSubmit,
      submitting,
      valid,
      submitSucceeded,
      submitFailed
    } = this.props;
    return (
      <Form onSubmit={handleSubmit(this.submit)}>
        <Field
          name="password"
          component={renderInput}
          type="password"
          placeholder="Hasło"
          validate={[required, minLengthPassword8, maxLengthPassword250]}
        />
        <Field
          name="confirmPassword"
          component={renderInput}
          type="password"
          placeholder="Powtórz hasło"
          validate={[required, isSamePassword]}
        />

        {submitSucceeded && <Success>Hasło zostało zmienione!</Success>}
        {valid &&
        submitFailed && (
          <Error>
            Wystąpił błąd przy ustawianiu nowego hasła! Najprawdopodobniej token
            wygasł. Spróbuj zresetować hasło ponownie
          </Error>
        )}

        <Button loading={submitting} color="primary" type="submit">
          Ustaw hasło!
        </Button>
      </Form>
    );
  }
}
const Success = styled.div.attrs({ className: "text-success" })`
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 20px;
  text-align: center;
`;
const Error = Success.extend.attrs({ className: "text-danger" })``;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  width: 300px;
  margin: 40px 0;

  @media (max-width: 400px) {
    width: 100%;
  }
`;

SetPasswordForm = reduxForm({
  form: "setPasswordForm"
})(SetPasswordForm);

SetPasswordForm = connect(null, { setPassword })(SetPasswordForm);

export default SetPasswordForm;



// WEBPACK FOOTER //
// ./src/auth/SetPasswordForm.js